// @flow

export type ActionName = {
	GET: string,
	SUCCESS: string,
	FAIL?: string,
};

export const GET_COMPARISON_DATA: ActionName = {
	GET: 'GET_COMPARISON_DATA.GET',
	SUCCESS: 'GET_COMPARISON_DATA.SUCCESS',
};

export const GET_AVG_GRADES: ActionName = {
	GET: 'GET_AVG_GRADES.GET',
	SUCCESS: 'GET_AVG_GRADES.SUCCESS',
};

export const GET_TOP_GRADES: ActionName = {
	GET: 'GET_TOP_GRADES.GET',
	SUCCESS: 'GET_TOP_GRADES.SUCCESS',
};

export const GET_CITIES: ActionName = {
	GET: 'GET_CITIES.GET',
	SUCCESS: 'GET_CITIES.SUCCESS',
	FAIL: 'GET_CITIES.FAIL',
};

export const GET_STUDIES: ActionName = {
	GET: 'GET_STUDIES.GET',
	SUCCESS: 'GET_STUDIES.SUCCESS',
	FAIL: 'GET_STUDIES.FAIL',
};
